import { RoiInterpretedType } from '~/domain/dicom/dicomstructureset';
import { InterpretedTypeGroup } from './types';

export const INTERPRETED_TYPE_GROUPS: readonly InterpretedTypeGroup[] = [
    {
        labelId: 'structureSet.filter.oar',
        defaultLabel: 'OAR',
        types: [RoiInterpretedType.ORGAN, RoiInterpretedType.AVOIDANCE],
    },
    {
        labelId: 'structureSet.filter.targets',
        defaultLabel: 'Targets',
        types: [
            RoiInterpretedType.PTV,
            RoiInterpretedType.CTV,
            RoiInterpretedType.GTV,
        ],
    },
    {
        labelId: 'structureSet.filter.support',
        defaultLabel: 'Support',
        types: [
            RoiInterpretedType.EXTERNAL,
            RoiInterpretedType.SUPPORT,
            RoiInterpretedType.FIXATION,
            RoiInterpretedType.BOLUS,
        ],
    },
    {
        labelId: 'structureSet.filter.markers',
        defaultLabel: 'Markers',
        types: [
            RoiInterpretedType.MARKER,
            RoiInterpretedType.ISOCENTER,
            RoiInterpretedType.REGISTRATION,
        ],
    },
] as const;

export const TYPE_SORT_ORDER: Record<string, number> = {
    [RoiInterpretedType.EXTERNAL]: 0,
    [RoiInterpretedType.ORGAN]: 1,
    [RoiInterpretedType.OAR]: 1,
    [RoiInterpretedType.AVOIDANCE]: 1,
    [RoiInterpretedType.CAVITY]: 1,
    [RoiInterpretedType.GTV]: 2,
    [RoiInterpretedType.CTV]: 3,
    [RoiInterpretedType.PTV]: 4,
    [RoiInterpretedType.SUPPORT]: 5,
    [RoiInterpretedType.FIXATION]: 5,
    [RoiInterpretedType.BOLUS]: 5,
    [RoiInterpretedType.MARKER]: 6,
    [RoiInterpretedType.ISOCENTER]: 6,
    [RoiInterpretedType.REGISTRATION]: 6,
};

export const NEW_SS_SENTINEL = '__new__';
